/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {clearUser, configureMetrics, flush, setApplication, setFilter, setUser} from '../metrics/lazyMetrics';
import fetchApi from '../network/fetch';
import graphql from '../network/graphql';
import type {InternalApi} from '@adobe/exc-app/internal';
import type {Configuration as NetworkConfiguration} from '@adobe/exc-app/network';

const internal: InternalApi = {
  clearUser,
  configureMetrics,
  configureNetwork(config: NetworkConfiguration): void {
    //drill down config to fetch API.
    fetchApi.configure(config);
    //drill down config to graphql API.
    graphql.configure(config);
  },
  flush,
  setApplication,
  setFilter,
  setUser
};

export default internal;
